import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as CookieConsent from "vanilla-cookieconsent";

function Footer() {
  const { role } = useSelector((state) => state.mainFun.user);
  const { t } = useTranslation();

  return (
    <footer className="footer ">
      <div className="container-xxl d-flex flex-column gap-3 py-3 align-items-end">
        <section className="d-flex w-100 justify-content-between flex-wrap gap-3 gap-lg-5">
          <p className="text-upper-first flex-grow-1">
            {t("powered_by")}{" "}
            <a
              href="https://plusone.expert"
              target="_blank"
              className="green-txt text-decoration-underline"
            >
              PlusOne health
            </a>{" "}
            GmbH
          </p>
          {role && (
            <>
              <Link
                to={`${role}/termsofuse`}
                className="green-txt text-upper-first"
              >
                {t("terms_use")}
              </Link>
              <Link
                to={`${role}/privacypolicy`}
                className="green-txt text-upper-first"
              >
                {t("privacy_policy")}
              </Link>
              {localStorage.token && (
                <p
                  onClick={() => CookieConsent.showPreferences()}
                  className="green-txt pointer text-capitalize"
                >
                  {t("cookies_pref")}
                </p>
              )}
            </>
          )}
        </section>
        <p>
          <strong>Support:</strong>{" "}
          <a
            className="green-txt"
            href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`}
          >
            {import.meta.env.VITE_SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
